import { gray1 } from 'emerald-ui/dist/globals/colors';
import { createGlobalStyle } from 'styled-components';

export const TrackingModuleGlobalStyles = createGlobalStyle`
    body {
        background: ${gray1};
        color: white;
    }

    #__next {
        height: 100vh;
        display: flex;
        flex-direction: column;
    }
`;
